//
//
//

/**
 *
 * NOTICE OF LICENSE
 *
 * This source file is released under commercial license by Lamia Oy.
 *
 * @copyright Copyright (c) Lamia Oy (https://lamia.fi)
 *
 */

/**
 * SVG Icon
 *
 * @version 0.1.0
 */
export default {
    name: 'OpusIcon',
    props: {
        code: {
            type: String,
            required: false,
            default: undefined,
        },
        classNames: {
            type: String,
            required: false,
            default: '',
        },
        /**
         * Url to fetch the icon from
         */
        src: {
            type: String,
            required: false,
            default: undefined,
        },
        /**
         * Icon size, defaults to m if not provided
         */
        size: {
            type: String,
            required: false,
            default: 'm',
        },
    },
    computed: {
        componentInstance() {
            return async () => await import(`~/assets/icon/${this.code}.svg?inline`);
        },
    },
};
